import React from "react";
import LeaseDetails from "./LeaseDetails";
import { withRouter } from "react-router-dom";
import apiUrl from "../apiUrlConstant";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseDetailsContainer extends React.Component {
  state = {
    leaseMenus: [],
    history: [],
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    fetch(
      `${apiUrl.apiUrl.url}/lease-view/fetch-lease-menus?leaseId=` +
      this.props.match.params.id + `&getAll=true`, {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseMenus: data.data,
          history: data.history,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    return (
      <div
        className="parentContainer"
      >
        <div
          className="customTabs leaseDetails">
          <div className="absoluteItemForTopBar d-flex align-items-center gap-4">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>View Lease</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Lease Details</a>
                </li>
              </ul>
            </div>
          </div>
          <LeaseDetails
            leaseChecked={false}
            leaseId={this.props.match.params.id}
            leaseMenus={this.state.leaseMenus}
            history={this.state.history}
            selectedOption="Parties, Landlord & Unit Details"
          />
        </div>
      </div>
    );
  }
}
export default withRouter(LeaseDetailsContainer);
